import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AuthenticationGuard } from './guards/authentication/authentication.guard';
import { CustomDomainGuard } from './guards/custom-domain/custom-domain.guard';
import { IsProjectActiveGuard } from './guards/is-project-active/is-project-active.guard';
import { orderedAsyncGuards } from './helpers/ordered-guards.helper';
import { ProjectResolver } from './resolvers/project.resolver';

const routes: Routes = [
  {
    path: '',
    redirectTo: '404',
    pathMatch: 'full',
    title: '404'
  },
  {
    path: '404',
    title: '404',
    loadChildren: () => import('./pages/not-found/not-found.page.module').then(m => m.NotFoundPageModule)
  },
  {
    path: ':projectSlug',
    redirectTo: ':projectSlug/signin',
    pathMatch: 'full'
  },
  {
    path: ':projectSlug/signin/code',
    title: 'Sign-in',
    canActivate: [CustomDomainGuard, AuthenticationGuard],
    loadChildren: () => import('./pages/sign-in/sign-in.page.module').then(m => m.SignInPageModule),
    data: {
      isCodeSignin: true
    }
  },
  {
    path: ':projectSlug/signin',
    title: 'Sign-in',
    canActivate: [CustomDomainGuard, AuthenticationGuard],
    loadChildren: () => import('./pages/sign-in/sign-in.page.module').then(m => m.SignInPageModule)
  },
  {
    path: ':projectSlug/signup',
    title: 'Sign-up',
    canActivate: [CustomDomainGuard, AuthenticationGuard],
    loadChildren: () => import('./pages/sign-up/sign-up.page.module').then(m => m.SignUpPageModule)
  },
  {
    path: ':projectSlug/legal',
    title: 'Legal',
    loadChildren: () => import('./pages/legal/legal.page.module').then(m => m.LegalPageModule),
    canActivate: [CustomDomainGuard]
  },
  // Prevent /:projectSlug/areas from falling through to the wildcard 404 when no area slug could not be determined.
  // Sign-in route will handle redirecting to the correct area if the user is authenticated.
  {
    path: ':projectSlug/areas',
    redirectTo: ':projectSlug/signin',
    pathMatch: 'full'
  },
  {
    path: ':projectSlug/areas',
    title: 'Area',
    loadChildren: () => import('./pages/area/area.page.module').then(m => m.AreaPageModule),
    canActivate: [orderedAsyncGuards([CustomDomainGuard, AuthenticationGuard, IsProjectActiveGuard])],
    resolve: { project: ProjectResolver }
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full'
  }
];

@NgModule({
  declarations: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
